import { TableHead } from '@mui/material';
import { styled } from '@mui/material/styles';
import theme from '../../../common/theme';

export const StyledTableHead = styled(TableHead)`
  background-color: ${theme.palette.grey[200]};
  border-bottom: 'none';
`;
